const Errr = require('errr');
const jwtDecode = require('jwt-decode').default;
const { BehaviorSubject } = require('rxjs');
const { filter } = require('rxjs/operators');

const getProxyRedirectUrl = require('../utils/get-proxy-redirect-url');
const Globals = require('../state/globals');
const Config = require('../state/config');
const { PlatformStatus, SessionURL, Errors } = require('../constants');

const {
  ACCESS_TOKEN,
  EXPIRATION,
  ID_TOKEN,
  REFRESH_TOKEN,
  IDENTITY_SWITCHED_CONTAINER_AT
} = require('../constants/local-storage');

class IdentityInfo {

  static async getIdentitySession() {
    this._stateObservable = this._stateObservable || new BehaviorSubject(PlatformStatus.LOADING);
    try {
      if (!this._state) {
        this._state = PlatformStatus.LOADING;
        const headers = {
          'Authorization': `Bearer ${localStorage.getItem('idToken')}`,
          'XbsProductUuid': Globals.getXbsProductUuid()
        };
        const url = getProxyRedirectUrl(`${Config.getPrincipleUrl()}${SessionURL}`);
        const response = await fetch(url, { headers });
        this._session = (await response.json()).data;
        this._state = PlatformStatus.LOADED;
        this._stateObservable.next(this._state);
        return this._session;
      }
      if (this._state === PlatformStatus.LOADING) {
        return new Promise((res) => {
          this._stateObservable.pipe(
            filter(status => status === PlatformStatus.LOADED)
          ).subscribe(() => {
            res(this._session);
          });
        });
      }
      if (this._state === PlatformStatus.LOADED) {
        return this._session;
      }
    } catch (err) {
      Errr.newError(Errors.GetSession.Message)
        .appendTo(err).throw();
    }

  }

  static clearIdentitySession() {
    delete this._state;
  }

  static setIdentitySession(session) {
    this._session = session || {};
  }

  static getIdentityTokens() {
    const identityTokens = {
      accessToken: localStorage.getItem(ACCESS_TOKEN),
      refreshToken: localStorage.getItem(REFRESH_TOKEN),
      idToken: localStorage.getItem(ID_TOKEN),
      expiration: localStorage.getItem(EXPIRATION)
    };
    return identityTokens;
  }

  static setIdentityTokens(authenticationResponse) {
    const { idToken, accessToken, refreshToken } = authenticationResponse;
    const decodedToken = jwtDecode(idToken.jwtToken);
    const expiresAt = new Date(decodedToken.exp);

    localStorage.setItem(ACCESS_TOKEN, accessToken.jwtToken);
    localStorage.setItem(ID_TOKEN, idToken.jwtToken);
    localStorage.setItem(EXPIRATION, JSON.stringify(expiresAt.valueOf()));
    if (refreshToken) {
      localStorage.setItem(REFRESH_TOKEN, refreshToken.token);
    }
  }

  static getIdToken() {
    return localStorage.getItem(ID_TOKEN);
  }

  static updateContainerTimestamp() {
    const currentTimestamp = (new Date()).getTime();
    localStorage.setItem(IDENTITY_SWITCHED_CONTAINER_AT, currentTimestamp);
  }

}

module.exports = IdentityInfo;

